<template>
  <PopUp
    :title="title"
    :isLoading="isLoading"
    :popUpActive="_popUpActive"
    :clickOutsideClose="clickOutsideClose"
    @click="$_onClosePopup"
  >
    <template>
      <slot />
    </template>
    <LlCancelPopupContent>
      <template v-slot:buttons>
        <WsButton001 width-stretch @click="$_onConfirm">
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </LlCancelPopupContent>
  </PopUp>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '資料尚未填寫完全',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    clickOutsideClose: {
      type: Boolean,
      default: true,
    },
    /** 由外層控制開關時傳入；未傳則使用內部 isActive.popup（ref 呼叫 $_onOpenPopup / $_onClosePopup） */
    visible: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    _popUpActive() {
      return this.visible !== undefined ? this.visible : this.isActive.popup;
    },
  },
  data() {
    return {
      isActive: {
        popup: false,
      },
    };
  },
  methods: {
    $_onClosePopup() {
      if (this.visible !== undefined) {
        this.$emit('close');
        return;
      }
      if (!this.isActive.popup) return;
      this.isActive.popup = false;
    },
    $_onOpenPopup() {
      this.isActive.popup = true;
    },
    $_onConfirm() {
      this.$emit('confirm');
      if (this.visible === undefined) this.$_onClosePopup();
    },
  },
};
</script>
